import axios from "axios";

export const http = axios.create({
  baseURL: import.meta.env.VITE_API_URL ?? "/api",
  timeout: 15_000,
  headers: { "Content-Type": "application/json" }
});

http.interceptors.request.use(config => {
  const token = localStorage.getItem("autoflow.accessToken");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

http.interceptors.response.use(response => {
  if (response.data && typeof response.data === "object" && "success" in response.data && "data" in response.data) {
    response.data = response.data.data;
  }
  return response;
}, error => {
  const apiMessage = error.response?.data?.message;
  const apiCode = error.response?.data?.code;
  if (typeof apiMessage === "string" && apiMessage.trim()) {
    error.message = apiMessage;
  } else if (Array.isArray(apiMessage) && apiMessage.length) {
    error.message = apiMessage.join("; ");
  }
  if (error.response?.status === 401 && !String(error.config?.url).includes("/auth/")) {
    localStorage.removeItem("autoflow.accessToken");
    localStorage.removeItem("autoflow.refreshToken");
    localStorage.removeItem("autoflow.user");
    window.location.assign("/login");
  }
  if (error.response?.status === 403 && apiCode === "PASSWORD_CHANGE_REQUIRED") {
    try {
      const stored = JSON.parse(localStorage.getItem("autoflow.user") ?? "null") as Record<string,unknown>|null;
      if (stored) localStorage.setItem("autoflow.user",JSON.stringify({...stored,mustChangePassword:true}));
    } catch {
      localStorage.removeItem("autoflow.user");
    }
    if (window.location.pathname!=="/change-password") window.location.assign("/change-password");
  }
  return Promise.reject(error);
});
